/* ===== Cart Attributes Sync ===== */

function updateCartAttributes() {
  const inputs = document.querySelectorAll('[data-cart-attribute]');
  const attributes = {};

  inputs.forEach(input => {
    if (input.name) {
      attributes[input.name] = input.value;
    }
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes })
  });
}

function resetCartAttributesIfEmpty() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count === 0) {
        const managedKeys = ['配送時間'];
        const cleared = {};

        Object.keys(cart.attributes || {}).forEach(key => {
          cleared[key] = '';
        });
        /* 定義済みのものだけ削除（ある程度運用後こちらに変える）
        managedKeys.forEach(key => {
            cleared[key] = '';
        });
        */

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: cleared
          })
        });
      }
    });
}

function syncCartAttributes() {
  const inputs = document.querySelectorAll('[data-cart-attribute]');
  if (!inputs.length) return;

  const attributes = {};

  inputs.forEach(input => {
    let key = input.name;

    // attributes[...] 対応
    const match = key.match(/^attributes\[(.+)\]$/);
    if (match) key = match[1];

    // select、checkbox、hiddenは強制保存
    if (input.tagName === 'SELECT') {
        attributes[key] = input.value;
        return;
    }
    if (input.type === 'checkbox') {
        attributes[key] = input.checked ? 'true' : '';
        return;
    }
    if (input.type === 'hidden') {
        attributes[key] = input.value;
        return;
    }
    
    // その他は空でなければ保存
    if (input.value !== '') {
        attributes[key] = input.value;
    }
  });

  if (Object.keys(attributes).length === 0) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes })
  });
}

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-cart-attribute]')) {
    updateCartAttributes();
  }
});

document.addEventListener('cart:updated', () => {
  resetCartAttributesIfEmpty();
  syncCartAttributes();
});

document.addEventListener('DOMContentLoaded', () => {
  resetCartAttributesIfEmpty();
  syncCartAttributes();
});